/**
 * @generated SignedSource<<16c93dd5ff5b065363dab5657ada36d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "versionId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "versionId",
        "variableName": "versionId"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "acceptReview",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AcceptReviewMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AcceptReviewMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "09300717a5c6cadbadbe30d7fa6e0afc",
    "id": null,
    "metadata": {},
    "name": "AcceptReviewMutation",
    "operationKind": "mutation",
    "text": "mutation AcceptReviewMutation(\n  $versionId: ID!\n) {\n  acceptReview(versionId: $versionId) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "9b4f5f99445e087087b816c6063c7278";

export default node;
